import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { useColorMode } from '../../theme/ColorModeProvider';
import { getChartPalette } from '../../theme/colorMode';

const PieChartWrapper = ({ data }) => {
  const { mode } = useColorMode();
  const chart = getChartPalette(mode);
  return (
    <div>
      <ReactEcharts
        option={{
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: '50%',
              data: data,
              label: { color: chart.text },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }}

      />
    </div>
  );
};

export default PieChartWrapper;